import * as React from 'react'

import { Content } from '../../atoms/Content/index'
import { IntakeContainer } from '../../organisms/Intakes/IntakeContainer'
import { IntakeInfoBar } from '../../molecules/IntakeInfoBar'
import { IntakeScaleBar } from '../../organisms/Intakes/IntakeScaleBar'
import { MenuPage } from '../MenuPage'
import { ScaleExplanationSmall } from '../../atoms/ScaleExplanationSmall'
import { intake1Steps } from '../../organisms/Intakes/intake1Steps'
import {ScaleExplanation} from '../../atoms/ScaleExplanation'
import { IntakeStepRadioButtons } from 'src/organisms/Intakes/IntakeStepRadioButtons'


const lang = process.env.REACT_APP_LANGUAGE === 'es' ? 'es' : 'en'

const translations = {
  'en': {
    childInformation: 'Child Information',
    completedByParent: 'completed by parent',
    extremelyUntrue: 'Extremely\nUntrue',
    quiteUntrue: 'Quite\mUntrue',
    slightlyUntrue: 'Slightly\nUntrue',
    neitherTrueNorUntrue: 'Neither True\nnor untrue',
    slightlyTrue: 'Slightly\ntrue',
    quiteTrue: 'Quite\ntrue',
    extremelyTrue: 'Extremely\mtrue',
    almostNever: 'Almost\nNever',
    sometimes: 'Somtimes',
    often: 'Often',
    almostAlways: 'Almost\nAlways',
    veryMuchDisagreement: 'Very much in Disagreement',
    veryMuchInAgreement: 'Very Much in Agreement',
    aLittleDisagreement: 'Slightly Disagree',
    notDisagreement: 'Neither agree nor disagree',
    aLittleAgree: 'Agree',
    notImportant: 'Not Important',
    aLittleImportant: 'A Little Important',
    somewhatImportant: 'Somewhat Important',
    veryImportant: 'Very Important',
    extremelyImportant: 'Extremely Important',
    religiousScale1: 'Not at all',
    religiousScale2: 'A bit',
    religiousScale3: 'A lot',
  },
  'es': {
    childInformation: 'Información del niño',
    completedByParent: 'Completado por la madre y padre',
    extremelyUntrue: 'Extremadamente falso',
    quiteUntrue: 'Bastante\nfalso',
    slightlyUntrue: 'Ligeramente\nfalso',
    neitherTrueNorUntrue: 'Ni cierto\nni falso',
    slightlyTrue: 'Ligeramente\ncierto',
    quiteTrue: 'Bastante\ncierto',
    extremelyTrue: 'Extremadamente\ncierto',
    almostNever: 'Casi\nnunca',
    sometimes: 'A\nveces',
    often: 'Frecuentemente',
    almostAlways: 'Casi\nsiempre',
    veryMuchDisagreement: 'Completamente\nen desacuerdo',
    veryMuchInAgreement: 'Completamente\nen acuerdo',
    aLittleDisagreement: 'En Desacuerdo',
    notDisagreement: 'No en desacuerdo\n ni en acuerdo',
    aLittleAgree: 'En acuerdo',
    notImportant: 'No\nImportante',
    aLittleImportant: 'Un poco\nImportante',
    somewhatImportant: 'Algo\nImportante',
    veryImportant: 'Muy\nImportante',
    extremelyImportant: 'Extremadamente\nImportante',
    religiousScale1: 'Para nada',
    religiousScale2: 'A veces',
    religiousScale3: 'Mucho',
  },
}

export class Intake1Page extends MenuPage {


  get hasIntakeInfoBar () {
    return true
  }

  public componentDidMount(): void {
    if(window.localStorage.getItem('userType') === 'PARENT_WEBTIPS_ES_EXTENSION'){
      const hasPablo = intake1Steps.findIndex((step) => step.name === 'characterChoice')

      if(hasPablo === -1){
        intake1Steps.push({
          Component: IntakeStepRadioButtons, completed: intake => !!intake.characterChoice,
          label: `Elige un personaje para navegar L-WebTIPS.`, name: 'characterChoice',
           options: [
            { label: <div><img src={'https://uci-images.s3.us-west-1.amazonaws.com/images/body@2x.png'} style={{height:'200px'}}/>Anna</div>, value: 'anna' }, 
            { label: <div><img src={'https://uci-images.s3.us-west-1.amazonaws.com/images/pablo-assets/body@2x.png'} style={{height:'200px'}}/>Pablo</div>, value: 'pablo' },
          ],
        })
      }
      
    }
  }

  public renderContent() {
    
    return (
      <div>
        <IntakeInfoBar>
        <h1>{translations[lang].childInformation}</h1>
        <p>{translations[lang].completedByParent}</p>
        </IntakeInfoBar>
        <IntakeScaleBar id="intake-scale-1" fromId="intake-step-3" fromOffset={150} toId="intake-step-9" toOffset={150}>
        <ScaleExplanationSmall labels={[
          translations[lang].extremelyUntrue, translations[lang].quiteUntrue, translations[lang].slightlyUntrue, translations[lang].neitherTrueNorUntrue,
          translations[lang].slightlyTrue, translations[lang].quiteTrue, translations[lang].extremelyTrue,
        ]} />
        </IntakeScaleBar>
        <IntakeScaleBar id="intake-scale-2" fromId="intake-step-14" fromOffset={250} toId="intake-step-25" toOffset={250}>
        <ScaleExplanationSmall labels={[
          translations[lang].almostNever, translations[lang].sometimes, translations[lang].often, translations[lang].almostAlways,
        ]} />
        </IntakeScaleBar>
        <IntakeScaleBar id="intake-scale-3" fromId="intake-step-29" fromOffset={250} toId="intake-step-42" toOffset={250}>
          <ScaleExplanationSmall labels={[
            translations[lang].veryMuchDisagreement, translations[lang].aLittleDisagreement, translations[lang].notDisagreement, translations[lang].aLittleAgree, translations[lang].veryMuchInAgreement,
          ]} />
        </IntakeScaleBar>
        <IntakeScaleBar id="intake-scale-4" fromId="intake-step-43" fromOffset={250} toId="intake-step-53" toOffset={250}>
          <ScaleExplanationSmall start={-1} labels={[
            translations[lang].notImportant, translations[lang].aLittleImportant, translations[lang].somewhatImportant, translations[lang].veryImportant, translations[lang].extremelyImportant,
          ]} />
        </IntakeScaleBar>
        <IntakeScaleBar id="intake-scale-5" fromId="intake-step-54" fromOffset={150} toId="intake-step-60" toOffset={150}>
          <ScaleExplanationSmall labels={[
            translations[lang].religiousScale1, translations[lang].religiousScale2, translations[lang].religiousScale3,
          ]} />
        </IntakeScaleBar>
        <Content>
        <IntakeContainer nextPage="/contents/01" steps={intake1Steps} />
        </Content>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Intake1Page/index.tsx